module.exports = __webpack_public_path__ + "img/blog-3.28ea2c62.png";